<template>
  <div>
    <form
      :action="url"
      ref="form"
      method="post"
      novalidate="novalidate"
      :target="isIframe ? '_blank' : '_self'"
      class="height-0"
    >
      <input
        type="text"
        name="username"
        placeholder="Username"
        :value="account.username"
        required
      /><br />
      <input
        type="password"
        name="password"
        placeholder="Password"
        :value="account.password"
        required
      /><br />
      <input type="hidden" name="d" value="www.joker123.net" />
      <input type="hidden" name="dk" value="RDb6sEufGixpg8c8Mn7LHEwJ4RE=" />
    </form>
    <button class="button full-100 is-primary" @click="handlePlayOnWeb()">
      {{ $t('playGameBtn') }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'LoginSlotJoker',
  props: {
    account: {
      type: Object
    },
    trigger: {
      type: Number
    }
  },
  watch: {
    trigger: {
      // immediate: true,
      async handler() {
        this.handlePlayOnWeb()
      }
    }
  },
  data() {
    return {
      url: 'https://www.joker123.net/SignIn',
      isIframe: process.env.VUE_APP_IFRAME === 'true'
    }
  },
  methods: {
    handlePlayOnWeb() {
      this.$refs.form.submit()
    }
  }
}
</script>

<style scoped lang="scss">
.height-0 {
  height: 0px !important;
  visibility: hidden;
}
</style>
